/* Dirty Laundry theme script: filters, quick view, bag drawer (Shopify cart), menu, size guide. */
(() => {
  const $ = s => document.querySelector(s);
  const $$ = s => [...document.querySelectorAll(s)];
  const esc = s => String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const money = c => "$" + (c / 100).toFixed(2);
  const short = c => "$" + (c % 100 ? (c / 100).toFixed(2) : String(c / 100));
  const reduced = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const CFG = window.DL || { freeShip: 10000, cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cartJs: "/cart.js", root: "/" };
  const LV = { "95": { name: "Boil wash", tub: "tub6" }, "60": { name: "Hot wash", tub: "tub4" }, "30": { name: "Cold wash", tub: "tub1" } };

  let DATA = [];
  try { DATA = JSON.parse(($("#dl-products") || {}).textContent || "[]"); } catch (e) { DATA = []; }
  const BY = Object.fromEntries(DATA.map(p => [String(p.id), p]));

  /* ---------- toast ---------- */
  let tt;
  function toast(msg, label, fn) {
    const t = $("#toast"), b = $("#toastBtn");
    if (!t) return;
    $("#toastMsg").textContent = msg;
    if (label) { b.hidden = false; b.textContent = label; b.onclick = () => { t.hidden = true; fn(); }; } else b.hidden = true;
    t.hidden = false;
    clearTimeout(tt);
    tt = setTimeout(() => { t.hidden = true; }, 3600);
  }

  /* ---------- overlays ---------- */
  const isOpen = id => { const el = document.getElementById(id); return el && !el.hidden; };
  function lock() { document.documentElement.classList.toggle("locked", isOpen("qv") || isOpen("drawer") || isOpen("menu")); }
  let bagReturn = null;

  /* ---------- cart ---------- */
  let cart = null;
  async function fetchCart() {
    const r = await fetch(CFG.cartJs, { headers: { Accept: "application/json" } });
    cart = await r.json();
    renderBag();
    return cart;
  }
  async function addToCart(variantId, qty = 1) {
    const r = await fetch(CFG.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || "Couldn't add that to your bag.");
    await fetchCart();
    const c = $("#bagCount");
    if (c) { c.classList.remove("bump"); void c.offsetWidth; c.classList.add("bump"); }
  }
  async function changeLine(key, quantity) {
    const r = await fetch(CFG.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) { toast(data.description || "Couldn't update your bag."); return; }
    cart = data;
    renderBag();
  }

  function renderBag() {
    if (!cart) return;
    const count = cart.item_count, sub = cart.total_price;
    const c = $("#bagCount");
    if (c) { c.textContent = count; c.classList.toggle("has", count > 0); }
    if (!$("#drawer")) return;
    $("#drCount").textContent = count;
    const left = Math.max(0, CFG.freeShip - sub);
    $("#shipMsg").textContent = count === 0 ? `Free shipping on orders over ${short(CFG.freeShip)}.` : left > 0 ? `You're ${short(left)} away from free shipping.` : "You've unlocked free shipping.";
    $("#shipBar").style.width = Math.min(100, (sub / CFG.freeShip) * 100) + "%";
    $("#lines").innerHTML = cart.items.map(it => {
      const size = (it.options_with_values && it.options_with_values[0] && it.options_with_values[0].value) || it.variant_title || "";
      const img = it.image ? `<img src="${esc(it.image)}${it.image.includes("?") ? "&" : "?"}width=160" alt="" width="72" height="90">` : "";
      return `<li class="line">
        <a class="studio" href="${esc(it.url)}" aria-label="${esc(it.product_title)}">${img}</a>
        <div>
          <p class="l-name">${esc(it.product_title)}</p>
          <p class="l-var">${esc(size)}</p>
          <div class="qty"><button data-dec="${esc(it.key)}" data-q="${it.quantity}" aria-label="One less ${esc(it.product_title)}">−</button><span>${it.quantity}</span><button data-inc="${esc(it.key)}" data-q="${it.quantity}" aria-label="One more ${esc(it.product_title)}">+</button></div>
        </div>
        <div class="l-right"><span class="price">${money(it.final_line_price)}</span><button class="rm" data-rm="${esc(it.key)}">Remove</button></div>
      </li>`;
    }).join("");
    $("#empty").hidden = count > 0;
    $("#drFoot").hidden = count === 0;
    $("#subtotal").textContent = money(sub);
  }

  function openBag() {
    if (!$("#drawer")) { location.href = "/cart"; return; }
    bagReturn = document.activeElement;
    $("#drawer").hidden = false;
    $("#scrim").hidden = false;
    lock();
    $("#drClose").focus();
    fetchCart().catch(() => {});
  }
  function closeBag() {
    $("#drawer").hidden = true;
    $("#scrim").hidden = true;
    lock();
    if (bagReturn && document.contains(bagReturn)) bagReturn.focus();
  }

  /* ---------- quick view ---------- */
  const qv = { id: null, vid: null, opener: null };
  function setQvImg(i) {
    const p = BY[qv.id];
    const src = p.imgs[i];
    if (src) $("#qvImg").src = src;
    $("#qvImg").alt = `${p.n} tee`;
    $$("#qvThumbs button").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.i === String(i))));
  }
  function openQV(id, opener) {
    const p = BY[String(id)];
    if (!p || !$("#qv")) return false;
    Object.assign(qv, { id: String(id), vid: null, opener });
    const lv = LV[p.t];
    $("#qvWash").outerHTML = lv
      ? `<span id="qvWash" class="wash static w${p.t}"><svg class="i"><use href="#${lv.tub}"/></svg>${p.t}° ${lv.name}</span>`
      : `<span id="qvWash" hidden></span>`;
    $("#qvTitle").textContent = p.n;
    $("#qvPrice").innerHTML = `${money(p.price)}<small>AUD</small>`;
    $("#qvQuote").textContent = p.q ? `“${p.q}”` : "";
    $("#qvQuote").hidden = !p.q;
    $("#qvContains").textContent = p.c || "";
    $("#qvContains").hidden = !p.c;
    $("#qvColour").textContent = p.col || "";
    $("#qvColour").parentElement.hidden = !p.col;
    $("#qvPrint").textContent = p.pr || "See the full details page.";
    $("#qvLink").href = p.url;
    $("#qvMsg").hidden = true;
    $("#qvSizes").innerHTML = p.v.map(v => `<button class="sz" data-vid="${v.id}" aria-pressed="false"${v.ok ? "" : " disabled"}>${esc(v.s)}</button>`).join("");
    $("#qvThumbs").innerHTML = p.imgs.length > 1 ? p.imgs.map((src, i) =>
      `<button class="thumb-b" data-i="${i}" aria-pressed="false" aria-label="Show image ${i + 1}"><img src="${esc(src)}" alt="" width="64" height="80"></button>`).join("") : "";
    $("#qvAdd").textContent = p.avail ? `Add to bag — ${short(p.price)}` : "Sold out";
    $("#qvAdd").disabled = !p.avail;
    setQvImg(0);
    $("#qv").hidden = false;
    lock();
    $("#qvClose").focus();
    return true;
  }
  function closeQV(restore = true) {
    $("#qv").hidden = true;
    lock();
    if (restore && qv.opener && document.contains(qv.opener)) qv.opener.focus();
  }
  if ($("#qv")) {
    $("#qvThumbs").addEventListener("click", e => { const b = e.target.closest("[data-i]"); if (b) setQvImg(+b.dataset.i); });
    $("#qvSizes").addEventListener("click", e => {
      const b = e.target.closest("[data-vid]");
      if (!b || b.disabled) return;
      qv.vid = b.dataset.vid;
      $$("#qvSizes button").forEach(x => x.setAttribute("aria-pressed", String(x === b)));
      $("#qvMsg").hidden = true;
    });
    $("#qvAdd").addEventListener("click", async () => {
      if (!qv.vid) { $("#qvMsg").hidden = false; const first = $("#qvSizes button:not([disabled])"); if (first) first.focus(); return; }
      const btn = $("#qvAdd"); btn.disabled = true;
      try { await addToCart(qv.vid); closeQV(false); openBag(); }
      catch (err) { toast(err.message); }
      finally { btn.disabled = false; }
    });
    $("#qvClose").addEventListener("click", () => closeQV());
    $("#qv").addEventListener("click", e => { if (e.target === $("#qv")) closeQV(); });
    $("#qvSizeGuide").addEventListener("click", () => closeQV(false));
  }

  /* ---------- bag events ---------- */
  if ($("#drawer")) {
    $("#lines").addEventListener("click", e => {
      const b = e.target.closest("button");
      if (!b) return;
      if (b.dataset.inc) changeLine(b.dataset.inc, +b.dataset.q + 1);
      else if (b.dataset.dec) changeLine(b.dataset.dec, +b.dataset.q - 1);
      else if (b.dataset.rm) changeLine(b.dataset.rm, 0);
    });
    $("#drClose").addEventListener("click", closeBag);
    $("#scrim").addEventListener("click", closeBag);
    $("#emptyShop").addEventListener("click", e => {
      if (document.getElementById("shop")) { e.preventDefault(); closeBag(); document.getElementById("shop").scrollIntoView({ behavior: reduced() ? "auto" : "smooth" }); }
    });
  }
  const bagBtn = $("#bagBtn");
  if (bagBtn) bagBtn.addEventListener("click", e => { e.preventDefault(); openBag(); });

  /* ---------- menu ---------- */
  function openMenu() { $("#menu").hidden = false; $("#menuBtn").setAttribute("aria-expanded", "true"); lock(); $("#menuClose").focus(); }
  function closeMenu(restore) { $("#menu").hidden = true; $("#menuBtn").setAttribute("aria-expanded", "false"); lock(); if (restore) $("#menuBtn").focus(); }
  if ($("#menuBtn") && $("#menu")) {
    $("#menuBtn").addEventListener("click", openMenu);
    $("#menuClose").addEventListener("click", () => closeMenu(true));
    $("#menu").addEventListener("click", e => { if (e.target.closest("a")) closeMenu(false); });
  }

  /* ---------- wash filter (home page) ---------- */
  const grid = $("#grid");
  const cards = grid ? $$("#grid .card:not(.promo)") : [];
  const counts = { all: DATA.length };
  DATA.forEach(p => { if (p.t) counts[p.t] = (counts[p.t] || 0) + 1; });
  $$("[data-count]").forEach(el => { el.textContent = counts[el.dataset.count] || 0; });
  $$("[data-shop]").forEach(b => {
    const n = counts[b.dataset.shop] || 0;
    b.textContent = n ? `Shop ${n} tee${n === 1 ? "" : "s"} →` : "Coming soon";
  });
  let filter = "all";
  function renderPills() {
    const pills = $("#pills");
    if (!pills) return;
    const n = { all: cards.length };
    cards.forEach(c => { if (c.dataset.t) n[c.dataset.t] = (n[c.dataset.t] || 0) + 1; });
    const opts = [["all", "All", null], ["95", "95° Boil", "tub6"], ["60", "60° Hot", "tub4"], ["30", "30° Cold", "tub1"]].filter(([k]) => k === "all" || n[k]);
    pills.innerHTML = opts.map(([k, label, tub]) =>
      `<button class="pill p${k}" id="pill-${k}" data-filter="${k}" aria-pressed="${filter === k}">${tub ? `<svg class="i"><use href="#${tub}"/></svg>` : ""}${label}<span>${n[k] || 0}</span></button>`).join("");
  }
  function setFilter(k, fromPills, scroll) {
    if (!grid) return;
    filter = k;
    let shown = 0;
    cards.forEach(c => { const on = k === "all" || c.dataset.t === k; c.hidden = !on; if (on) shown++; });
    $$("#grid .promo").forEach(pr => { pr.hidden = k !== "all"; });
    const sc = $("#shopCount"); if (sc) sc.textContent = shown;
    renderPills();
    if (fromPills) { const b = document.getElementById("pill-" + k); if (b) b.focus(); }
    else if (scroll) document.getElementById("shop").scrollIntoView({ behavior: reduced() ? "auto" : "smooth" });
  }
  if (grid) {
    renderPills();
    const w = new URLSearchParams(location.search).get("wash");
    if (w && (w === "all" || LV[w])) setFilter(w, false, false);
  }

  /* ---------- size table ---------- */
  const rows = $("#sizeRows");
  if (rows) {
    const table = (rows.dataset.sizes || "").split(/\n/).map(l => l.split(",").map(s => s.trim())).filter(r => r.length >= 3 && r[0]);
    const renderSizes = unit => {
      const f = v => unit === "in" ? (parseFloat(v) / 2.54).toFixed(1) : v;
      rows.innerHTML = table.map(([s, a, b]) => `<tr><td>${esc(s)}</td><td>${esc(f(a))} ${unit}</td><td>${esc(f(b))} ${unit}</td></tr>`).join("");
      $$("[data-unit]").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.unit === unit)));
    };
    $$("[data-unit]").forEach(b => b.addEventListener("click", () => renderSizes(b.dataset.unit)));
    renderSizes("cm");
  }

  /* ---------- product page ---------- */
  const pdForm = document.getElementById("pdForm");
  if (pdForm) {
    pdForm.addEventListener("submit", async e => {
      e.preventDefault();
      const id = (new FormData(pdForm)).get("id");
      if (!id) return;
      const btn = pdForm.querySelector("[type=submit]"); btn.disabled = true;
      try { await addToCart(id); openBag(); }
      catch (err) { toast(err.message); }
      finally { btn.disabled = false; }
    });
    $$("[data-pd-img]").forEach(b => b.addEventListener("click", () => {
      $("#pdImg").src = b.dataset.pdImg;
      $$("[data-pd-img]").forEach(x => x.setAttribute("aria-pressed", String(x === b)));
    }));
  }

  /* ---------- global clicks + keys ---------- */
  document.addEventListener("click", async e => {
    const o = e.target.closest("[data-open]");
    if (o && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      if (openQV(o.dataset.open, o)) e.preventDefault();
      return;
    }
    const a = e.target.closest("[data-add]");
    if (a) {
      a.disabled = true;
      try { await addToCart(a.dataset.add); toast(`${a.dataset.name}, size ${a.dataset.size}, added`, "View bag", openBag); }
      catch (err) { toast(err.message); }
      finally { a.disabled = false; }
      return;
    }
    const f = e.target.closest("[data-filter]");
    if (f && grid) {
      e.preventDefault();
      if (isOpen("menu")) closeMenu(false);
      setFilter(f.dataset.filter, !!f.closest("#pills"), !f.closest("#pills"));
    }
  });
  document.addEventListener("keydown", e => {
    if (e.key !== "Escape") return;
    if (isOpen("qv")) closeQV();
    else if (isOpen("drawer")) closeBag();
    else if (isOpen("menu")) closeMenu(true);
  });

  /* ---------- custom tee form: return to it after Shopify sends it ---------- */
  const customSec = document.getElementById("custom");
  if (customSec && (location.search.includes("contact_posted=true") || customSec.querySelector(".note-ok, .note-err"))) {
    setTimeout(() => customSec.scrollIntoView({ behavior: "auto" }), 50);
  }

  fetchCart().catch(() => {});
})();
